import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Wireframeyeppy = () => {
  return (
    <div className="wireframe_yeppy p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Wireframes</h2>
            <p>
              After going through multiple rounds of sketching, we transitioned
              to the creation of wireframes. Here's an introduction to some
              preliminary wireframes for various modules.
            </p>
          </Col>
        </Row>

        <Row className="padd_top">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h4>Apps Wireframes</h4>
            <div className="wire_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/apps_wire.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1668}
                height={445}
              />
            </div>
          </Col>
        </Row>
        <Row className="padd_top">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h4>Web Wireframes</h4>
            <div className="wire_img">
              <StaticImage
                src="../../../images/case-studies/yeppy/web_wire.png"
                alt="TekRevol"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={1668}
                height={252}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Wireframeyeppy;
